/* eslint-disable no-restricted-syntax */
import i18n from 'i18next';
import { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';
import { IPresentationModel } from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import { SlideInterface } from '@tencent/docs-api';
import { BaseAnalyzer } from '../base/base-analyzer';

interface IMasterInfo {
    name: string;
    hasCover: boolean;
    hasContents: boolean;
    hasSection: boolean;
    hasEnd: boolean;
    unUsedLayouts: {name: string, id: string}[];
}

type IResult = SlideInterface.CheckResultItem;

/**
 * 母版版式检查规则：
 * 母版是否包含封面页、目录页、章节页、结束页
 */
export class MachineMasterAnalyzer extends BaseAnalyzer<IResult> {
    private title = i18n.t('母版合规性检测');
    private description = i18n.t('检查母版和版式的名称是否合规');
    private level = 'warning' as const;

    public async calculateResult(presentation: IPresentationModel): Promise<IResult> {
        const masterList: IMasterInfo[] = presentation.masterList.map((master) => {
            const layoutList = master.layoutList.map((layout: ILayoutModel) => ({
                name: layout.name,
                id: layout.id ?? '',
                isRepeat: false,
            }));
            const hasCover = layoutList.some(layout => layout.name.includes('封面'));
            const hasContents = layoutList.some(layout => layout.name.includes('目录'));
            const hasSection = layoutList.some(layout => layout.name.includes('章节'));
            const hasEnd = layoutList.some(layout => layout.name.includes('结束'));

            const unUsedLayouts = layoutList.filter(layout =>
                !presentation.children.some(slide => slide.layoutId === layout.id));
            return { name: master.themeName, hasCover, hasContents, hasSection, hasEnd, unUsedLayouts };
        });

        // 重新组织数据用于结果输出
        const errorMessages: SlideInterface.CheckErrorMessage[] = [];
        const { level } = this;
        masterList.forEach((masterInfo) => {
            if (!masterInfo.hasCover) {
                errorMessages.push({ level, description: i18n.t(`母版[${masterInfo.name}]缺少名为“封面页”的版式`) });
            }
            if (!masterInfo.hasContents) {
                errorMessages.push({ level, description: i18n.t(`母版[${masterInfo.name}]缺少名为“目录页”的版式`) });
            }
            if (!masterInfo.hasSection) {
                errorMessages.push({ level, description: i18n.t(`母版[${masterInfo.name}]缺少名为“章节页”的版式`) });
            }
            if (!masterInfo.hasEnd) {
                errorMessages.push({ level, description: i18n.t(`母版[${masterInfo.name}]缺少名为“结束页”的版式`) });
            }
            masterInfo.unUsedLayouts.forEach((repeatInfo) => {
                errorMessages.push({ level, description: i18n.t(`母版[${masterInfo.name}]中的版式[${repeatInfo.name}]未使用`) });
            });
        });
        const passed = errorMessages.length <= 0;
        if (passed) {
            return { passed, title: this.title, description: this.description };
        }
        return { passed, title: this.title, description: this.description, errorMessages };
    }
}
